import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/searchDropdownBuyItAgain/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showSearchDropdownBuyItAgainSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showSearchDropdownBuyItAgainSelector };
